module.exports = __webpack_public_path__ + "img/10_20.d4e3429a.png";